import React, { useState, useEffect } from "react";
import "./Destaque.css";
import { Link, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import ExameCategoryCard from "../ExameCategoryCard/ExameCategoryCard";
import clinicaConfig from "../../clinicaConfig.js";
import { ReactComponent as Results } from "../Assets/icon-resultado-exames.svg";


const FloatingButton = () => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <div className="floating-container">
      {isVisible && (
        <div className="greeting-bubble">
          <span>Confira seus resultados de forma rápida e segura!</span>
          <button className="close-bubble" onClick={() => setIsVisible(false)}>
            &times;
          </button>
        </div>
      )}

      <a
        href={'/resultados-exames'}
        target="_blank"
        rel="noopener noreferrer"
        className="float-btn"
        aria-label="Ver resultados de exames"
      >
        <Results className="icon-svg" />
      </a>
    </div>
  );
};


const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
  </svg>
);

const normalizeText = (text) =>
  text ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";

const Destaque = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const API_BASE_URL = clinicaConfig.REACT_APP_API_BASE_URL || 'http://localhost:4000';

  const categories = ["Sangue", "Fezes", "Urina", "Imagem"];

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null);

        const clientDomain = window.location.hostname;
        console.log('Destaque - Domínio detectado:', clientDomain);

        const headers = {
          'X-Client-Domain': clientDomain,
          'Content-Type': 'application/json'
        };

        console.log('Destaque - Fazendo requisição para:', `${API_BASE_URL}/public/products`);
        console.log('Destaque - Headers:', headers);

        const response = await fetch(`${API_BASE_URL}/public/products`, { headers });

        console.log('Destaque - Status da resposta:', response.status);

        if (!response.ok) {
          throw new Error(`Erro ao buscar produtos: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        console.log('Destaque - Dados recebidos:', data);

        if (data.success) {
          const sortedData = data.products.sort((a, b) => a.name.localeCompare(b.name));
          setAllProducts(sortedData);
          console.log('Destaque - Produtos carregados:', sortedData.length);
        } else {
          throw new Error(data.message || 'Falha ao buscar produtos.');
        }
      } catch (err) {
        console.error("Destaque - Erro ao carregar produtos:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [API_BASE_URL]);

  const getExamsByCategory = (category) => {
    const normalizedCategory = normalizeText(category);
    return allProducts.filter(product => normalizeText(product.category) === normalizedCategory);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/Lista-de-exames?search=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  if (loading) {
    return (
      <div className="destaque-page-content">
        <div className="destaque-loading-wrapper">
          <ClipLoader size={70} color="var(--primary)" />
          <p className="destaque-loading-text">Carregando exames disponíveis...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="destaque-page-content">
        <div className="destaque-error-wrapper">
          <h3 className="destaque-error-title">Erro ao carregar exames</h3>
          <p className="destaque-error-message">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="destaque-error-button"
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="destaque-page-content">
      <section className="destaque-hero-section">
        <div className="destaque-hero-overlay"></div>
        <div className="destaque-hero-content">
          <div className="destaque-hero-text">
            <h1 className="destaque-hero-title">Exames Laboratoriais de Qualidade</h1>
            <p className="destaque-hero-subtitle">
              Resultados precisos com tecnologia de ponta e <span className="destaque-hero-accent">preços acessíveis</span>
            </p>
          </div>
          
          <div className="destaque-search-wrapper">
            <form onSubmit={handleSearchSubmit} className="destaque-search-form">
              <div className="destaque-search-icon-wrapper">
                <SearchIcon />
              </div>
              <input
                type="text"
                placeholder="Busque por nome do exame ou categoria..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="destaque-search-input"
                aria-label="Buscar exame"
              />
              <button type="submit" className="destaque-search-btn" aria-label="Buscar">
                Buscar
              </button>
            </form>
          </div>

          <div className="destaque-hero-cta">
            <Link to="/Lista-de-exames">
              <button className="destaque-cta-primary">Ver Todos os Exames</button>
            </Link>
            <Link to="/todos-medicos">
              <button className="destaque-cta-secondary">Nossos Profissionais</button>
            </Link>
          </div>
        </div>
      </section>

      <section className="destaque-categories-section">
        <div className="destaque-section-header">
          <h2 className="destaque-section-title">Categorias de Exames</h2>
          <p className="destaque-section-description">Encontre o exame que você precisa</p>
        </div>
        
        <div className="destaque-cards-grid-container">
          {categories.map((category) => (
            <ExameCategoryCard
              key={category}
              category={category}
              exams={getExamsByCategory(category)}
            />
          ))}
        </div>
      </section>

      <FloatingButton />
    </div>
  );
};

export default Destaque;